import { render } from "./GainApiNextRuns.vue?vue&type=template&id=4b1dddb6&scoped=true&ts=true"
import script from "./GainApiNextRuns.vue?vue&type=script&lang=ts"
export * from "./GainApiNextRuns.vue?vue&type=script&lang=ts"

import "./GainApiNextRuns.vue?vue&type=style&index=0&id=4b1dddb6&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1dddb6"]])

export default __exports__